export default __webpack_public_path__ + "static/media/SIGN_UP_ARROW_BACK.22fba926.svg";